exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js??ref--6-oneOf-3-1!../../node_modules/postcss-loader/src/index.js??postcss!./subgroups.css"), "");
exports.i(require("-!../../node_modules/css-loader/index.js??ref--6-oneOf-3-1!../../node_modules/postcss-loader/src/index.js??postcss!./save-the-date.css"), "");

// module
exports.push([module.id, ".subgroups-section {\n    display: flex;\n    flex-direction: row;\n    margin-top: 2em;\n}\n\n@media (max-width: 1200px) {\n    .subgroups-section{\n        flex-direction: column-reverse;\n    }\n}\n\n", ""]);

// exports
